export {
  DeckCardEditorMobile,
  DeckCardEditorMobileProps,
} from './DeckCardEditorMobile';
